import { jsx as _jsx } from "react/jsx-runtime";
const colours = {
    draft: 'bg-stone-200 text-stone-700',
    active: 'bg-green-100 text-green-800',
    closed: 'bg-amber-100 text-amber-800',
    archived: 'bg-stone-100 text-stone-500',
};
export function CampaignStatusBadge({ status }) {
    return (_jsx("span", { className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colours[status] || colours.draft}`, children: status }));
}
